import { AccountService } from "@3gaam/api/services";
import { IdentityInput, IdentityOutput } from "@3gaam/api/types/account";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  isLoggedIn: boolean;
  Token: IdentityOutput["Token"] | null;
  isForbidden: boolean;
  isCurTokenValid: boolean;
  isValidationFinished: boolean;
  loggedOut: boolean;
}

function initialToken() {
  try {
    let token = JSON.parse(
      localStorage.getItem("auth") || "",
    ) as IdentityOutput["Token"];

    return token;
  } catch (e) {
    return null;
  }
}
const initialState: AuthState = {
  isLoggedIn: true,
  Token: initialToken(),
  isCurTokenValid: false,
  isForbidden: false,
  isValidationFinished: false,
  loggedOut: false,
};

export const identityAction = createAsyncThunk(
  "account/identity",
  async (_, { rejectWithValue }) => {
    try {
      let data: IdentityInput = {};

      const consulteeId = localStorage.getItem("ConsulteeId");
      if (!consulteeId) {
        data.Role = "Member";
      }
      const res = await AccountService.identity(data);
      return res.data;
    } catch (e: any) {
      return rejectWithValue({ data: e.data, status: e.status });
    }
  },
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    changeLoginStateAction: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    logoutAction: (state, action: PayloadAction<boolean>) => {
      state.loggedOut = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(identityAction.fulfilled, (state, action) => {
      const payload: IdentityOutput = action.payload;

      if (state.Token?.AccessToken && !action.payload.Identified) {
        state.isCurTokenValid = false;
        state.isLoggedIn = false;
      } else {
        if (!payload.Identified) {
          localStorage.setItem("auth", JSON.stringify(payload.Token));
          state.Token = payload.Token;
        }

        state.isCurTokenValid = true;
        state.isValidationFinished = true;
      }
    });

    builder.addCase(identityAction.rejected, (state, action: any) => {
      const statusCode = action.payload.status;

      if (statusCode === 401) {
        localStorage.clear();
        state.isLoggedIn = false;
      } else if (statusCode === 403) {
        state.isForbidden = true;
      } else if (statusCode === 409) {
        let details = action.payload.data?.Details;

        if (details?.AccessToken) {
          localStorage.clear();
          state.Token = details;
          localStorage.setItem("auth", JSON.stringify(details));
          state.isCurTokenValid = true;
        }
      }
      state.isValidationFinished = true;
    });
  },
});

export const { changeLoginStateAction, logoutAction } = authSlice.actions;

export default authSlice.reducer;
